/**
 * The kit's palette for the active theme (light / dark) plus its CSS variables. Kept apart from tokens.js so the
 * tokens stay a plain module (the app shell imports them; tokens must not import the app back).
 */
import { useMemo } from 'react';
import { useTheme } from '@/App';
import { paletteOf, tokenVars } from './tokens';

export function useCpvTokens() {
  const { isDark } = useTheme();
  return useMemo(() => ({ ...paletteOf(isDark), vars: tokenVars(isDark), isDark }), [isDark]);
}

export default useCpvTokens;
